import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Segment } from 'semantic-ui-react';
import { getFooterHTML, getSystemName } from '../helpers';

const Footer = () => {
  const { t } = useTranslation();
  const systemName = getSystemName();
  const [footer, setFooter] = useState(getFooterHTML());
  let remainCheckTimes = 5;

  const loadFooter = () => {
    let footer_html = localStorage.getItem('footer_html');
    if (footer_html) {
      setFooter(footer_html);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (remainCheckTimes <= 0) {
        clearInterval(timer);
        return;
      }
      remainCheckTimes--;
      loadFooter();
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Segment vertical>
      <Container textAlign='center' style={{ color: '#666666' }}>
        {footer ? (
          <div
            className='custom-footer'
            dangerouslySetInnerHTML={{ __html: footer }}
          ></div>
        ) : (
          <div className='custom-footer' style={{ padding: '20px 0', borderTop: '1px solid #eaeaea', marginTop: '20px' }}>
            <span style={{ fontWeight: '500' }}>{systemName} {process.env.REACT_APP_VERSION}</span>
            <span style={{ margin: '0 10px' }}>|</span>
            <span>{t('footer.built_by')} <strong>My Studio</strong></span>
            <span style={{ margin: '0 10px' }}>|</span>
            <span>Powered by <a href='https://reactjs.org' target='_blank' style={{ color: '#764ba2' }}>React</a></span>
          </div>
        )}
      </Container>
    </Segment>
  );
};

export default Footer;
